import React from 'react';
import { Container, Card } from 'react-bootstrap';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => (
  <div className="privacy-policy-section d-flex justify-content-center">
    <Container className="my-5" style={{ maxWidth: '1200px' }}>
      <h1 className="text-center mb-4">Privacy Policy</h1>
      <Card className="p-5 shadow-sm">
        <Card.Body>
          <div className="text-start privacy-text">
            <p><strong>Effective Date:</strong> July 2025</p>

            <p>
              This Privacy Policy outlines how ISIR.AI collects, uses, discloses, and safeguards personal data collected through our websites, services, and integrations. By accessing any ISIR.AI services, users consent to the practices described herein.
            </p>

            <h5>1. Information Collected</h5>
            <p>ISIR.AI may collect the following categories of data:</p>
            <ul>
              <li><strong>Personal Information:</strong> Names, emails, phone numbers, job titles, and organization names submitted via forms or platform usage.</li>
              <li><strong>Technical Information:</strong> Browser type, IP address, device info, session data, and user interactions for analytics and security.</li>
            </ul>

            <h5>2. Purpose of Data Use</h5>
            <ul>
              <li>Delivering and maintaining ISIR.AI platforms and services</li>
              <li>Managing user accounts and communication</li>
              <li>Responding to demo or contact requests</li>
              <li>Enhancing platform performance and usability</li>
              <li>Ensuring compliance with API providers and local laws</li>
            </ul>

            <h5>3. Data Disclosure</h5>
            <p>
              ISIR.AI does not sell personal data. Information may be shared with verified third-party processors (e.g., hosting providers, analytics platforms) under data processing agreements to support operations or comply with legal requirements.
            </p>

            <h5>4. LinkedIn Lead Sync API</h5>
            <p>
              ISIR.AI utilizes the LinkedIn Lead Sync API to receive information explicitly submitted via LinkedIn Lead Gen Forms. Such data is used exclusively for:
            </p>
            <ul>
              <li>Responding to demo or service inquiries</li>
              <li>Sharing relevant product information</li>
              <li>Sending legal and permitted updates or marketing content</li>
              <li>Developing professional engagement with relevant leads</li>
            </ul>
            <p>
              Communications can be unsubscribed via provided email links or by contacting <a href="mailto:info@isir.ai">info@isir.ai</a>. ISIR.AI follows LinkedIn’s platform terms and privacy compliance.
            </p>

            <h5>5. Cookies and Analytics</h5>
            <p>
              Cookies and analytics tools are used for improving user experience and site performance. Users may manage cookies via browser preferences. We utilize tools such as Google Analytics and may use session recording for diagnostic purposes.
            </p>

            <h5>6. Data Retention</h5>
            <p>
              Data is retained only as long as necessary for the purposes outlined. When no longer required, data is securely deleted or anonymized per regulatory standards.
            </p>

            <h5>7. Data Security</h5>
            <p>
              ISIR.AI applies industry-standard safeguards including access controls, encryption, and system monitoring. However, no digital system can guarantee absolute security.
            </p>

            <h5>8. Responsible Use of AI</h5>
            <p>
              ISIR.AI is committed to deploying artificial intelligence responsibly. All models are reviewed for fairness, transparency, and bias mitigation. We avoid applications that may violate user rights or data protection norms.
            </p>

            <h5>9. International Data Transfers</h5>
            <p>
              Where applicable, ISIR.AI ensures lawful mechanisms (such as SCCs or DPAs) are in place for cross-border data transfers to jurisdictions outside of the user's region.
            </p>

            <h5>10. User Rights</h5>
            <p>
              Users may request access, correction, or deletion of their personal information by contacting <a href="mailto:info@isir.ai">info@isir.ai</a>. We may require identity verification before fulfilling such requests.
            </p>

            <h5>11. Policy Updates</h5>
            <p>
              This Privacy Policy may be revised to reflect service or legal changes. The effective date will be updated accordingly. Continued use of ISIR.AI services constitutes acknowledgment of changes.
            </p>

            <h5>12. Contact</h5>
            <p>
              For privacy-related inquiries or feedback, contact:<br />
              <strong>Email:</strong> <a href="mailto:info@isir.ai">info@isir.ai</a><br />
            </p>
          </div>
        </Card.Body>
      </Card>
    </Container>
  </div>
);

export default PrivacyPolicy;
